import React from 'react';
import Button from './ui/Button';
import { icons } from './ui/Icons';

/**
 * Componente: ErrorBoundary
 * Captura erros de renderização do React e exibe interface amigável
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Atualiza o state para exibir a UI de fallback na próxima renderização
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log do erro para serviço de monitoramento (ex: Sentry, LogRocket)
    console.error('ErrorBoundary capturou erro:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    // Recarrega a página
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // UI de fallback personalizada
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
          <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
            <div className="mb-6">
              {icons.alert({ className: 'h-16 w-16 text-red-500 mx-auto' })}
            </div>
            
            <h1 className="text-2xl font-bold text-gray-900 mb-3">
              Algo deu errado
            </h1>
            
            <p className="text-gray-600 mb-6">
              Desculpe, ocorreu um erro inesperado. Nossa equipe foi notificada e está trabalhando para resolver o problema.
            </p>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="mb-6 text-left bg-gray-100 p-4 rounded-lg overflow-auto max-h-40">
                <p className="text-xs font-mono text-red-600 mb-2">
                  <strong>Erro:</strong> {this.state.error.toString()}
                </p>
                <p className="text-xs font-mono text-gray-600">
                  <strong>Stack:</strong>
                  <pre className="whitespace-pre-wrap">
                    {this.state.errorInfo?.componentStack}
                  </pre>
                </p>
              </div>
            )}

            <div className="flex gap-3">
              <Button
                variant="secondary"
                onClick={() => window.history.back()}
                className="flex-1"
              >
                {icons.chevronLeft({ className: 'h-4 w-4 mr-2 inline' })}
                Voltar
              </Button>
              <Button
                variant="primary"
                onClick={this.handleReset}
                className="flex-1"
              >
                Recarregar Página
              </Button>
            </div>

            <p className="text-sm text-gray-500 mt-6">
              Se o problema persistir, entre em contato com o suporte.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
